exports = module.exports = require("../../../../../../home/node/site/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.auto-complete-box {\n    display: inline;\n}\n", ""]);

// exports
